<div class="authScreen">
    <div class="box-login">
        <div class="logo">
            <img src="assets/img/logo.svg" alt="Punjab Group">
        </div>
        <div class="box-holder">
            <h2 *ngIf="!forgetPasswordFlag"><strong class="fw-bolder">Welcome to</strong><br>Punjab Group Solar O & M Portal</h2>
            <h1 *ngIf="!forgetPasswordFlag">Log In</h1>
            <h1 *ngIf="forgetPasswordFlag">Forget Password</h1>

            <h3 class="form-signin" *ngIf="forgetPasswordFlag">
                <button class="form-check-label btn btn-link primary" style="cursor: pointer;"
                    (click)="loginBack()">Back To Login</button>
            </h3>
            <div class="form-signin" *ngIf="this.loginFlag">
                <form [formGroup]="loginForm" (ngSubmit)="saveUser(loginForm)">
                    <div class="form-group">
                        <label for="username" class="form-label">Username or Email</label>
                        <input type="text" id="username" class="form-control" formControlName="username"
                            placeholder="Enter username or email" (focus)="hideErrorMessage()" />

                        <div *ngIf="f.username.touched && f.username.invalid" class="text-danger mt-1">
                            <div *ngIf="f.username.errors?.['required']">Username or email is required.</div>
                            <div *ngIf="f.username.errors?.['usernameOrEmail']">Enter a valid username or email.</div>
                        </div>
                    </div>

                    <!-- Password Field -->
                    <!-- <div class="form-group">
                        <label for="password" class="form-label">Password</label>
                        <input type="password" id="password" class="form-control" formControlName="password"
                            placeholder="Enter password" />

                        <div *ngIf="f.password.touched && f.password.invalid" class="text-danger mt-1">
                            <div *ngIf="f.password.errors?.['required']">Password is required.</div>
                        </div>
                    </div> -->
                    <!-- Password Field -->
                    <div class="form-group">
                        <label for="password" class="form-label">Password</label>
                        <div class="position-relative">
                            <input [type]="showPassword ? 'text' : 'password'" id="password" class="form-control pe-5"
                                formControlName="password" placeholder="Enter password" />
                            <span class="position-absolute top-50 translate-middle-y cursor-pointer"
                                style="right: 12px;" (click)="togglePasswordVisibility()">
                                <svg *ngIf="!showPassword" xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
                                    stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                    <circle cx="12" cy="12" r="3" />
                                </svg>
                                <svg *ngIf="showPassword" xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
                                    stroke-linecap="round" stroke-linejoin="round">
                                    <path
                                        d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a20.29 20.29 0 0 1 5.06-6.06M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a20.29 20.29 0 0 1-3.29 4.53" />
                                    <line x1="1" y1="1" x2="23" y2="23" />
                                    <path d="M14.12 14.12A3 3 0 1 1 9.88 9.88" />
                                </svg>
                            </span>
                        </div>

                        <div *ngIf="f.password.touched && f.password.invalid" class="text-danger mt-1">
                            <div *ngIf="f.password.errors?.['required']">Password is required.</div>
                        </div>
                    </div>
                    <div class="form-meta">
                        <!-- <label class="checkbox">
                            <input type="checkbox">
                            <span>Remember me</span>
                        </label> -->
                        <!-- <a routerLink="" (click)="showForget()">Forgot Password?</a> -->
                        <!-- <label class="form-check-label" for="auth-remember-check" (click)="showForget()">Forget
                            Password?</label> -->
                        <button class="form-check-label btn btn-link primary" (click)="showForget()">Forget
                            Password?</button>
                    </div>
                    <div class="btn-block">
                        <button type="submit" class="btn btn-dark w-100 lg" [disabled]="isLoggingIn">
                            <ng-container *ngIf="!isLoggingIn; else loggingIn">Login</ng-container>
                            <ng-template #loggingIn>
                                <span class="spinner-border spinner-border-sm align-middle me-2"></span>
                                Logging in...
                            </ng-template>
                        </button>
                    </div>
                </form>
            </div>
            <div class="form-signin" *ngIf="this.forgetPasswordFlag">
                <form class="gradient-custom" #forget="ngForm" (ngSubmit)="submitForget(forget)">
                    <div class="mb-3">
                        <label for="username" class="form-label">Email</label>
                        <input type="text" class="form-control" placeholder="Enter username" name="email" [(ngModel)]="
                            forgotPassword.email
                            " #email="ngModel" required />
                        <div>
                            <div class="has-danger text-left text-danger" *ngIf="
                            email.errors &&
                                    (email.dirty ||
                                    email.touched)
                                ">
                                Email is a
                                required field
                            </div>
                        </div>
                    </div>

                    <div class="d-flex justify-content-between">
                        <div class="form-check">

                            <label class="form-check-label" for="auth-remember-check">
                            </label>
                        </div>
                        <div class="form-check"></div>
                    </div>
                    <div class="mt-4">
                        <button class="btn btn-dark lg w-100" [disabled]="
                                !forget.valid
                            " type="submit">
                            Send Email
                        </button>
                    </div>
                    <!-- <div class="mt-4 text-center">
                        <div class="signin-other-title">
                            <h5 class="fs-13 mb-4 title">
                                Sign In with
                            </h5>
                        </div>

                        <div>
                            <button type="button"
                                class="btn btn-primary btn-icon waves-effect waves-light">
                                <i class="ri-facebook-fill fs-16"></i>
                            </button>
                            <button type="button"
                                class="btn btn-danger btn-icon waves-effect waves-light">
                                <i class="ri-google-fill fs-16"></i>
                            </button>
                            <button type="button"
                                class="btn btn-dark btn-icon waves-effect waves-light">
                                <i class="ri-github-fill fs-16"></i>
                            </button>
                            <button type="button"
                                class="btn btn-info btn-icon waves-effect waves-light">
                                <i class="ri-twitter-fill fs-16"></i>
                            </button>
                        </div>
                    </div> -->
                </form>
            </div>
        </div>
    </div>
    <div class="box-content">
        <!-- <div class="content-holder">
            <h2>" Join the renewable energy revolution<span> with ZeroCarbon solar solutions."</span></h2>
        </div> -->
    </div>
</div>
<ng-template>
    <div class="authScreen">
        <div class="box-login">
            <div class="box-holder">
                <div class="logo">
                    <!-- <img src="assets/img/logo-zc.png" alt="Zero Carbon">
            </div> -->
                    <div class="logo-wrap">
                        <svg viewBox="0 0 160 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M33.1962 31.8348L40.096 37.8299C42.0684 35.5621 43.5223 32.9979 44.4511 30.2894L35.8095 27.3104C35.2527 28.9354 34.3795 30.4754 33.1962 31.8348ZM36.3048 20.2308C36.6363 21.9552 36.6363 23.7312 36.3048 25.4555L45.277 27.1973C45.8308 24.3239 45.8308 21.3634 45.277 18.49L36.3048 20.2308ZM33.1962 13.8514C34.3797 15.2117 35.2529 16.7498 35.8093 18.375L44.4509 15.3979C43.5221 12.6894 42.0684 10.1243 40.0958 7.85644L33.1962 13.8514ZM22.8376 0C16.9878 0.000920907 11.1373 2.22712 6.68399 6.68026C-2.228 15.5922 -2.228 30.0938 6.68399 39.0057C11.1391 43.4609 16.9924 45.6888 22.8459 45.6888C28.1984 45.6888 33.5479 43.8201 37.8326 40.0928L31.8374 33.193C26.4564 37.8749 18.2675 37.6592 13.1495 32.5401C7.80178 27.1924 7.80178 18.4924 13.1495 13.1454C15.822 10.472 19.3343 9.13576 22.8459 9.13576C26.0582 9.13576 29.2679 10.2572 31.8376 12.4927L37.8327 5.59285C33.547 1.86594 28.1947 0 22.8413 0H22.8376Z"
                                fill="url(#paint0_linear_1521_3893)" />
                            <path
                                d="M55.1596 6.15037H65.1227L54.9003 19.2388V21.228H70.6509V17.9564H60.199L70.6509 4.52718V2.90473H55.1594L55.1596 6.15037ZM87.4407 17.8249H76.535V13.6884H87.0517V10.4694H76.535V6.25517H87.4407V2.90491H72.9003V21.2282H87.4407V17.8249ZM105.956 20.9919L100.408 14.7356C103.889 14.0291 105.041 11.49 105.041 8.97663C105.041 5.80963 102.764 2.9307 98.4437 2.90473C95.5388 2.90473 92.633 2.87784 89.7281 2.87784V21.2278H93.1831V15.1032H96.5076L101.847 21.228H105.957L105.956 20.9919ZM98.4437 6.12366C100.617 6.12366 101.586 7.58956 101.586 9.05546C101.586 10.5214 100.643 11.9882 98.4437 11.9882H93.1829V6.12366H98.4437ZM115.459 2.53802C109.124 2.53802 106.035 7.38107 106.035 12.1974C106.035 17.0138 109.02 21.6465 115.459 21.6465C121.899 21.6465 124.804 16.909 124.857 12.1714C124.908 7.38107 121.767 2.53802 115.459 2.53802ZM115.459 5.67905C119.778 5.67905 121.505 9.13411 121.453 12.2232C121.401 15.2327 119.778 18.4795 115.459 18.4795C111.14 18.4795 109.517 15.2596 109.438 12.2501C109.36 9.161 111.14 5.67905 115.459 5.67905ZM67.3257 38.2788C66.146 39.4826 64.3755 40.1374 62.8105 40.1374C58.3721 40.1374 56.6533 36.9694 56.6275 33.933C56.6016 30.8706 58.4749 27.5721 62.8105 27.5721C64.3755 27.5721 65.9665 28.1221 67.1461 29.2992L69.4038 27.0748C67.5574 25.2163 65.2478 24.2736 62.8105 24.2736C56.319 24.2736 53.267 29.1436 53.292 33.933C53.318 38.6974 56.1404 43.383 62.8105 43.383C65.4016 43.383 67.7878 42.519 69.6354 40.6604L67.3257 38.2788ZM85.5247 42.9644H89.2195L81.1631 24.6402H77.4682L69.4127 42.9644H73.0816L74.6206 39.5084H84.0105L85.5247 42.9644ZM82.6513 36.2887H75.9802L79.3157 28.4879L82.6513 36.2887ZM106.232 42.7282L100.683 36.472C104.164 35.7654 105.316 33.2263 105.316 30.713C105.316 27.546 103.039 24.6661 98.7196 24.6402C95.8138 24.6402 92.908 24.6142 90.0031 24.6142V42.9642H93.4581V36.8385H96.7826L102.123 42.9642H106.233L106.232 42.7282ZM98.7196 27.8602C100.892 27.8602 101.861 29.3261 101.861 30.792C101.861 32.2579 100.918 33.7238 98.7196 33.7238H93.4579V27.8602H98.7196ZM116.232 24.6403H107.541V42.9645H116.232C120.027 42.9645 123.09 41.6552 123.09 37.5713C123.09 36.4193 122.304 34.1423 120.158 33.4886C121.859 32.7292 122.54 31.3679 122.54 29.9549C122.54 26.2637 119.844 24.6403 116.232 24.6403ZM110.944 27.7814H116.232C118.43 27.7814 119.111 29.1953 119.111 30.0326C119.111 31.0799 118.404 31.9967 116.232 31.9967H110.944V27.7814ZM110.944 35.0322H116.232C117.645 35.0322 119.661 35.8962 119.661 37.5454C119.661 39.2724 117.645 39.7438 116.232 39.7438H110.944V35.0322ZM133.613 24.2736C127.278 24.2736 124.19 29.1167 124.19 33.933C124.19 38.7501 127.173 43.383 133.613 43.383C140.053 43.383 142.958 38.6446 143.01 33.9071C143.063 29.1167 139.921 24.2736 133.613 24.2736ZM133.613 27.4147C137.932 27.4147 139.66 30.8706 139.607 33.9597C139.555 36.9693 137.932 40.2151 133.613 40.2151C129.294 40.2151 127.671 36.9952 127.593 33.9857C127.514 30.8966 129.294 27.4147 133.613 27.4147ZM156.544 36.0008L147.565 24.6403H144.765V42.9645H148.22V30.6086L157.854 42.9903V42.9644H160V24.6144H156.544V36.0008Z"
                                fill="#424143" />
                            <defs>
                                <linearGradient id="paint0_linear_1521_3893" x1="4.60453e-05" y1="22.8446" x2="45.6923"
                                    y2="22.8446" gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#EE4424" />
                                    <stop offset="1" stop-color="#FFCB0C" />
                                </linearGradient>
                            </defs>
                        </svg>
                    </div>
                </div>
                <h1 *ngIf="!forgetPasswordFlag">Sign In</h1>
                <h1 *ngIf="forgetPasswordFlag">Forget Password</h1>

                <h3 class="form-signin" *ngIf="forgetPasswordFlag">
                    <button class="form-check-label btn btn-link primary" style="cursor: pointer;"
                        (click)="loginBack()">Back To Login</button>
                </h3>
                <!-- <p>This is a secure site. Please enter your login information to enter or you can register yourself. -->
                <!-- </p> -->
                <div class="form-signin" *ngIf="this.loginFlag">
                    <!-- <form class="gradient-custom" #applicationForm="ngForm" (ngSubmit)="saveUser(applicationForm)"> -->
                    <form [formGroup]="loginForm" (ngSubmit)="saveUser(loginForm)">

                        <!-- <div class="form-group">
                        <label>Email</label>
                        <input type="email" class="form-control" placeholder="admin@demo.com">
                    </div> -->
                        <!-- <div class="form-group">
                        <label for="username" class="form-label">User Name</label>
                        <input type="text" class="form-control" placeholder="Enter username"
                            name="username" [(ngModel)]="
                                user.username
                            " #username="ngModel" required (focus)="hideErrorMessage()"/>
                        <div>
                            <div class="has-danger text-left text-danger" *ngIf="
                                    username.errors &&
                                    (username.dirty ||
                                        username.touched)
                                ">
                                Username is a
                                required field
                            </div>
                        </div>
                    </div> -->

                        <!-- <div class="form-group">
                        <label>Password</label>
                        <input type="password" class="form-control" placeholder="********">
                    </div> -->
                        <div class="form-group">
                            <label for="username" class="form-label">Username or Email</label>
                            <input type="text" id="username" class="form-control" formControlName="username"
                                placeholder="Enter username or email" (focus)="hideErrorMessage()" />

                            <div *ngIf="f.username.touched && f.username.invalid" class="text-danger mt-1">
                                <div *ngIf="f.username.errors?.['required']">Username or email is required.</div>
                                <div *ngIf="f.username.errors?.['usernameOrEmail']">Enter a valid username or email.
                                </div>
                            </div>
                        </div>

                        <!-- Password Field -->
                        <div class="form-group">
                            <label for="password" class="form-label">Password</label>
                            <input type="password" id="password" class="form-control" formControlName="password"
                                placeholder="Enter password" />

                            <div *ngIf="f.password.touched && f.password.invalid" class="text-danger mt-1">
                                <div *ngIf="f.password.errors?.['required']">Password is required.</div>
                            </div>
                        </div>
                        <!-- <div class="form-group">
                                                   
                        <label class="form-label">Password</label>
                        <div class="position-relative auth-pass-inputgroup mb-3">
                            <input type="password" name="password" class="form-control pe-5"
                                [(ngModel)]="
                                    user.password
                                " #password="ngModel" placeholder="Enter your password"
                                required (focus)="hideErrorMessage()"/>
                            <div class="has-danger text-left text-danger" *ngIf="
                                    password.errors &&
                                    (password.dirty || password.touched)
                                ">
                                Password is a  required field
                            </div>
                        </div>
                    </div> -->
                        <!-- <div class="form-group">
                        <div class="has-danger text-left text-danger" *ngIf="loginError">
                            Incorrect Username / Password
                        </div>
                    </div> -->

                        <div class="form-meta">
                            <!-- <label class="checkbox">
                            <input type="checkbox">
                            <span>Remember me</span>
                        </label> -->
                            <!-- <a routerLink="" (click)="showForget()">Forgot Password?</a> -->
                            <label class="form-check-label" for="auth-remember-check" (click)="showForget()">Forget
                                Password?</label>
                        </div>
                        <div class="btn-block">
                            <button type="submit" class="btnPrimary rounded">Login</button>
                            <!-- <span class="text-12 d-block text-center mb-40">New on our platform? <a href="#">Create an account</a></span> -->
                            <!-- <span class="text-or"><span>or</span></span>
                        <ul class="social-networks">
                            <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                            <li><a href="#" class="google"><i class="fab fa-google"></i></a></li>
                            <li><a href="#" class="twitter"><i class="fab fa-twitter"></i></a></li>
                        </ul> -->
                        </div>
                    </form>
                </div>
                <div class="form-signin" *ngIf="this.forgetPasswordFlag">
                    <form class="gradient-custom" #forget="ngForm" (ngSubmit)="submitForget(forget)">
                        <div class="mb-3">
                            <label for="username" class="form-label">Email</label>
                            <input type="text" class="form-control" placeholder="Enter username" name="email"
                                [(ngModel)]="
                            forgotPassword.email
                            " #email="ngModel" required />
                            <div>
                                <div class="has-danger text-left text-danger" *ngIf="
                            email.errors &&
                                    (email.dirty ||
                                    email.touched)
                                ">
                                    Email is a
                                    required field
                                </div>
                            </div>
                        </div>

                        <div class="d-flex justify-content-between">
                            <div class="form-check">

                                <label class="form-check-label" for="auth-remember-check">
                                </label>
                            </div>
                            <div class="form-check"></div>
                        </div>
                        <div class="mt-4">
                            <button class="btn btn-success w-100 btnPrimary" [disabled]="
                                !forget.valid
                            " type="submit">
                                Send Email
                            </button>
                        </div>
                        <!-- <div class="mt-4 text-center">
                        <div class="signin-other-title">
                            <h5 class="fs-13 mb-4 title">
                                Sign In with
                            </h5>
                        </div>

                        <div>
                            <button type="button"
                                class="btn btn-primary btn-icon waves-effect waves-light">
                                <i class="ri-facebook-fill fs-16"></i>
                            </button>
                            <button type="button"
                                class="btn btn-danger btn-icon waves-effect waves-light">
                                <i class="ri-google-fill fs-16"></i>
                            </button>
                            <button type="button"
                                class="btn btn-dark btn-icon waves-effect waves-light">
                                <i class="ri-github-fill fs-16"></i>
                            </button>
                            <button type="button"
                                class="btn btn-info btn-icon waves-effect waves-light">
                                <i class="ri-twitter-fill fs-16"></i>
                            </button>
                        </div>
                    </div> -->
                    </form>
                </div>
            </div>
        </div>
        <div class="box-content">
            <div class="content-holder">
                <h2>" Join the renewable energy revolution<span> with ZeroCarbon solar solutions."</span></h2>
            </div>
        </div>
    </div>
</ng-template>
<!-- footer -->
<footer class="footer">
    <p class="mb-0">
        &copy; Punjab Group 2026. All rights reserved
    </p>
</footer>